import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { LicenseService } from 'src/app/services/license/license.service';
import { MasterService } from 'src/app/services/master/master.service';
import { CommonMessages } from 'src/app/shared/messages/messages.enum';

@Component({
  selector: 'app-list-subscription-license-route',
  templateUrl: './list-subscription-license-route.component.html',
  styleUrls: ['./list-subscription-license-route.component.css']
})
export class ListSubscriptionLicenseRouteComponent extends BaseComponent implements OnInit {
  @ViewChild('searchText', { static: true }) searchText: ElementRef;
  companyID = 0;
  selectedCompany: any = '';
  selectedLicense: any = '';
  licenseObj: any = [];
  currentUser;
  getCompanyobj: any = [];
  categoryObj: any = [];
  webCatTotal: number = 0;
  slCatPage = 1;
  slCatLimit = 10;
  slCatSkip = 0;
  slCatord = "asc";
  slCatColname = "license_code";
  constructor(private clientService: ClientService,
    private licenseService: LicenseService,
    private masterService: MasterService) {
    super();
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('userData'));
    if (this.currentUser.admin_customer_id != '0') {
      this.companyID = this.currentUser.admin_customer_id;
      this.selectedCompany = this.companyID;
      this.loadLicenses(this.selectedCompany);
      this.getRouteList();
    }
    if (this.currentUser.admin_customer_id == '0') this.getCompany();
  }
  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data;
      const working = this.bindWorkingCompany(this.getCompanyobj);
      if (working) {
        this.selectedCompany = working;
        this.loadLicenses(this.selectedCompany);
        this.getRouteList();
      }
      this.ngxSpinnerService.hide();
    }, error => {
      console.log(error);
    });
  }
  onCompanyChange(value?: any) {
    if (value !== undefined) {
      this.selectedCompany = value;
    }
    this.selectedLicense = '';
    this.slCatPage = 1;
    this.loadLicenses(this.selectedCompany);
    this.getRouteList();
  }
  loadLicenses(companyId) {
    this.licenseObj = [];
    if (!companyId) {
      return;
    }
    this.licenseService.gettingLicense(companyId).subscribe(data => {
      if (data.status && data.data) {
        this.licenseObj = data.data;
      } else {
        this.licenseObj = [];
      }
    }, error => {
      console.log(error);
      this.licenseObj = [];
    });
  }
  onLicenseChange(value?: any) {
    if (value !== undefined) {
      this.selectedLicense = value;
    }
    this.slCatPage = 1;
    this.getRouteList();
  }
  resetFilters() {
    this.selectedLicense = '';
    this.slCatPage = 1;
    this.slCatSkip = 0;
    if (this.searchText && this.searchText.nativeElement) {
      this.searchText.nativeElement.value = '';
    }
    if (this.companyID == 0) {
      this.selectedCompany = this.bindWorkingCompany(this.getCompanyobj) || '';
      this.loadLicenses(this.selectedCompany);
    }
    this.getRouteList();
  }
  onLimitChange() {
    this.slCatLimit = Number(this.slCatLimit) || 10;
    this.slCatPage = 1;
    this.getRouteList();
  }
  getRouteList() {
    let searchTerm = this.searchText && this.searchText.nativeElement ? this.searchText.nativeElement.value : '';
    this.slCatSkip = (this.slCatPage - 1) * this.slCatLimit;
    if (this.selectedCompany !== "") {
      this.ngxSpinnerService.show();
      this.masterService.getLicenseRouteList(this.selectedCompany, this.slCatLimit, this.slCatSkip, searchTerm, this.slCatColname, this.slCatord, this.selectedLicense).subscribe(data => {
        this.ngxSpinnerService.hide();
        if (data.status) {
          if (data.data.rows == null) { this.categoryObj = [] }
          else { this.categoryObj = data.data.rows }
          this.webCatTotal = data.data.total;
        } else {
          this.categoryObj = [];
          this.webCatTotal = 0;
        }
      }, error => { console.log(error); this.ngxSpinnerService.hide(); });
    } else {
      this.categoryObj = [];
      this.webCatTotal = 0;
      this.ngxSpinnerService.hide();
    }
  }
  setOrder(value: string) {
    this.slCatColname = value
    if (this.slCatord == 'asc') {
      this.slCatord = 'desc'
    } else {
      this.slCatord = 'asc'
    }
    this.getRouteList()
  }
  editPost(id: any) {
    localStorage.setItem("edit_subscription_license_route_id", id);
    localStorage.setItem("edit_subscription_license_route_company_id", this.selectedCompany);
    this.router.navigate(['/corporate/edit-subscription-license-route']);
  }
  updateStatus(event, id, status) {
    event.preventDefault();
    let obj = {
      isactive: (status == true) ? false : true
    }
    this.confirmationDialogService.confirm('Please confirm', 'Are you sure you want to change the status To' + ((obj.isactive) ? ' Active?' : ' In Active?'), 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.masterService.updateLicenseRouteStatus(this.selectedCompany, id, obj).subscribe(data => {
            if (data.status) {
              this.toastrService.success("Status Updated Successfully");
              this.getRouteList();
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log(CommonMessages.dialogDismissMessage));
  }
  delRoute(event, id) {
    event.preventDefault();
    this.confirmationDialogService.confirm('Please confirm', 'ARE YOU SURE YOU WANT TO DELETE ?', 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.masterService.deleteLicenseRoute(this.selectedCompany, id).subscribe(data => {
            if (data.status) {
              this.toastrService.success("License route deleted successfully");
              this.getRouteList();
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => console.log(CommonMessages.dialogDismissMessage));
  }
  ngAfterViewInit() {
    this.searchText.nativeElement.value = '';
    this.ngxSpinnerService.show();
    fromEvent(this.searchText.nativeElement, 'keyup')
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.slCatSkip = 0;
          this.slCatPage = 1;
        }),
        switchMap(data => this.masterService.getLicenseRouteList(this.selectedCompany, this.slCatLimit, this.slCatSkip, this.searchText.nativeElement.value, this.slCatColname, this.slCatord, this.selectedLicense))
      )
      .subscribe((res: any) => {
        if (res.status) {
          if (res.data.rows == null) { this.categoryObj = [] }
          else { this.categoryObj = res.data.rows }
          this.webCatTotal = res.data.total;
        } else {
          this.categoryObj = [];
          this.webCatTotal = 0;
        }
        this.ngxSpinnerService.hide();
      }, error => {
        this.categoryObj = [];
        this.webCatTotal = 0;
        this.ngxSpinnerService.hide();
      });
  }
}
